<template>
  <v-container fluid class="admin-workflow-details">
    <v-card v-if="!definition" variant="flat" class="admin-workflow-details__empty pa-5">
      <div class="d-flex align-start ga-3">
        <v-icon color="warning" size="24">mdi-alert-circle-outline</v-icon>
        <div>
          <div class="text-subtitle-1 font-weight-semibold ncrm-text-strong">
            {{ $t("admin.workflows.detail.notFoundTitle") }}
          </div>
          <div class="text-body-2 text-medium-emphasis mt-1">
            {{ $t("admin.workflows.detail.notFoundBody") }}
          </div>
          <v-btn class="mt-4" color="primary" variant="tonal" @click="goBackToList">
            <v-icon start>mdi-arrow-left</v-icon>
            {{ $t("admin.workflows.actions.backToList") }}
          </v-btn>
        </div>
      </div>
    </v-card>

    <component
      :is="workflowDetailComponent"
      v-else
      :definition="definition"
      @back="goBackToList"
    />
  </v-container>
</template>

<script>
import AdminMailjetEventMirrorWorkflow from "./workflows/AdminMailjetEventMirrorWorkflow.vue";
import AdminSelfRegistrationIntakeWorkflow from "./workflows/AdminSelfRegistrationIntakeWorkflow.vue";
import {
  ADMIN_WORKFLOW_KEYS,
  findAdminWorkflowDefinition,
} from "./workflows/adminWorkflowDefinitions.mjs";

export default {
  name: "AdminWorkflowDetailsPage",
  components: {
    AdminMailjetEventMirrorWorkflow,
    AdminSelfRegistrationIntakeWorkflow,
  },
  props: {
    workflowKey: {
      type: String,
      default: "",
    },
  },
  computed: {
    definition() {
      return findAdminWorkflowDefinition(this.workflowKey);
    },
    workflowDetailComponent() {
      if (this.workflowKey === ADMIN_WORKFLOW_KEYS.MAILJET_EVENT_MIRROR) {
        return "AdminMailjetEventMirrorWorkflow";
      }
      if (this.workflowKey === ADMIN_WORKFLOW_KEYS.SELF_REGISTRATION_INTAKE) {
        return "AdminSelfRegistrationIntakeWorkflow";
      }
      return null;
    },
  },
  methods: {
    goBackToList() {
      this.$router.push({ name: "AdminWorkflowsHome" });
    },
  },
};
</script>

<style scoped>
.admin-workflow-details {
  background: var(--app-page-background);
  min-height: 100%;
}

.admin-workflow-details__empty {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  border-radius: var(--app-radius-base);
}
</style>
